import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<g clip-path="url(#a)" stroke="currentColor"> <path d="M6 3v3.333L8 8" /> <circle cx="6" cy="6" r="5" /> </g> <defs> <clipPath id="a"> <path fill="currentColor" d="M0 0h12v12H0z" /> </clipPath> </defs>' }
  })
);